import { Directive, EmbeddedViewRef, Host, TemplateRef, ViewContainerRef } from '@angular/core';

export interface ModalContext<T> {
	$implicit: (result: T | undefined) => void;
	close: (result: T | undefined) => void;
}

@Directive({
	selector: '[appModal]',
	exportAs: 'appModal',
})
export class ModalDirective<T = unknown> {
	constructor(
		@Host() private readonly template: TemplateRef<ModalContext<T>>,
		private readonly viewContainerRef: ViewContainerRef,
	) { }

	public async show(): Promise<T | undefined> {
		let modal: EmbeddedViewRef<ModalContext<T>>;

		try {
			return await new Promise((resolve) => {
				modal = this.viewContainerRef.createEmbeddedView(this.template, { $implicit: resolve, close });
			});
		} finally {
			modal.destroy();
		}
	}
}
